export const isJsDom = () => {
  if (typeof window === 'undefined') return false

  return (
    // https://github.com/jsdom/jsdom/issues/1537
    navigator.userAgent.includes('Node.js') ||
    navigator.userAgent.includes('jsdom')
  )
}
